/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'

import Home from '@/pages/Home'
import Works from '@/pages/Works'
import About from '@/pages/About'
import Photos from '@/pages/Photos'
import Error from '@/pages/Error'
import Access from '@/pages/Access'

import Mercer from '@/contents/Mercer'
import Biscuit from '@/contents/Biscuit'
import TeaTwo from '@/contents/TeaTwo'
import Teamable from '@/contents/Teamable'
import Transcope from '@/contents/Transcope'
import Granton from '@/contents/Granton'
import Zigzag from '@/contents/Zigzag'
import Magritte from '@/contents/Magritte'
import WikiPrice from '@/contents/WikiPrice'
import Collision from '@/contents/Collision'
import RbiReport from '@/contents/RbiReport'
import RbiWebsite from '@/contents/RbiWebsite'
import Olasio from '@/contents/Olasio'
import RbiEmails from '@/contents/RbiEmails'
import RbiScheduler from '@/contents/RbiScheduler'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/access',
      name: 'Access',
      component: Access
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      alias: '/home'
    },
    {
      path: '/works',
      name: 'Works',
      component: Works
    },
    {
      path: '/photos',
      name: 'Photos',
      component: Photos
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/works/mercer',
      name: 'Mercer',
      component: Mercer
    },
    {
      path: '/works/biscuit',
      name: 'Biscuit',
      component: Biscuit
    },
    {
      path: '/works/t2',
      name: 'TeaTwo',
      component: TeaTwo
    },
    {
      path: '/works/teamable',
      name: 'Teamable',
      component: Teamable
    },
    {
      path: '/works/transcope',
      name: 'Transcope',
      component: Transcope
    },
    {
      path: '/works/granton',
      name: 'Granton',
      component: Granton
    },
    {
      path: '/works/zigzag',
      name: 'Zigzag',
      component: Zigzag
    },
    {
      path: '/works/magritte',
      name: 'Magritte',
      component: Magritte
    },
    {
      path: '/works/wikiprice',
      name: 'WikiPrice',
      component: WikiPrice
    },
    {
      path: '/works/collision',
      name: 'Collision',
      component: Collision
    },
    {
      path: '/works/rbi-report',
      name: 'RbiReport',
      component: RbiReport
    },
    {
      path: '/works/rbi-website',
      name: 'RbiWebsite',
      component: RbiWebsite
    },
    {
      path: '/works/olasio',
      name: 'Olasio',
      component: Olasio
    },
    {
      path: '/works/rbi-emails',
      name: 'RbiEmails',
      component: RbiEmails
    },
    {
      path: '/works/rbi-scheduler',
      name: 'RbiScheduler',
      component: RbiScheduler
    },
    {
      path: '*',
      name: 'Error',
      component: Error
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 200)
    })
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-110410306-1',
  router
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js